export function optionsCategories(data = []) {
  return [
    { value: 'todas', label: 'Todas' },
    ...data.map(({ id, nome }) => ({
      value: id,
      label: nome,
    })),
  ]
}
